import { atom } from "jotai";
import { stationsState } from "./stationsState";

export const stationsListState = atom((get) =>
  get(stationsState).map((station) => station.name)
);
